let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l1bMV")).then(() => parcelRequire('6b4Xr'));